
import { Button } from "@/components/ui/button";

export const AdvertiseHero = () => {
  const scrollToContact = () => {
    const contactForm = document.getElementById('contact-form');
    if (contactForm) {
      contactForm.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="bg-gradient-to-b from-primary/20 to-background py-16 md:py-20">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center space-y-6">
          <h1 className="text-4xl md:text-5xl font-bold text-primary">
            Reach Local Homeowners in OKC
          </h1>
          <p className="text-xl text-muted-foreground">
            Home Pros OKC connects thousands of local homeowners with trusted 
            home service professionals every month. Put your business in front 
            of homeowners in OKC!
          </p>
          <div className="pt-4">
            <Button 
              onClick={scrollToContact}
              size="lg"
              className="bg-primary hover:bg-primary/90 text-white"
            >
              Get Started
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
